// ── Case When slot helpers (pure) ────────────────────────────────────────
// LEGACY per-case code: {..., mode: "builder"|"code", expr: {v:1, lang:"js",
// src, reviewed}}. Still evaluated by the engine and still saved, but the UI
// can no longer create it (block-level code lives in blockCode.js). Only the
// read side and the import reset remain here.

export function isCodeCase(cs) {
  return !!cs && cs.mode === 'code';
}

// One line for the read-only preview.
export function oneLine(src, max = 140) {
  const s = String(src ?? '').replace(/\s+/g, ' ').trim();
  return s.length > max ? s.slice(0, max - 1) + '…' : s;
}

export function needsReview(cs) {
  return isCodeCase(cs) && cs.expr?.reviewed === false;
}

// Imported pipelines never arrive pre-approved: every code expression in an
// imported file is marked unreviewed, whatever the file says — block-level
// code (logic_mode "code") and legacy per-case code alike. Returns new step
// objects (inputs untouched). Server-side duplicate keeps `reviewed`.
export function resetReviewOnImport(steps) {
  return (steps || []).map((s) => {
    const cfg = s?.config;
    if (!cfg || typeof cfg !== 'object') return s;
    let next = cfg;
    // Also a dormant block (logic_mode builder) that still holds code: switching
    // back to Code later must not skip review.
    if (cfg.code && typeof cfg.code === 'object' && !Array.isArray(cfg.code)) {
      next = { ...next, code: { ...cfg.code, reviewed: false } };
    }
    // An "apply only when" gate holding code (even one currently in Builder).
    const aw = cfg.apply_when;
    if (aw && typeof aw === 'object' && aw.expr && typeof aw.expr === 'object') {
      next = { ...next, apply_when: { ...aw, expr: { ...aw.expr, reviewed: false } } };
    }
    if (Array.isArray(cfg.cases)) {
      let changed = false;
      const cases = cfg.cases.map((cs) => {
        if (cs && cs.mode === 'code' && cs.expr && typeof cs.expr === 'object') {
          changed = true;
          return { ...cs, expr: { ...cs.expr, reviewed: false } };
        }
        return cs;
      });
      if (changed) next = { ...next, cases };
    }
    return next === cfg ? s : { ...s, config: next };
  });
}

// How many of a step's cases are in code mode (for the canvas summary).
export function codeCaseCount(cases) {
  return (cases || []).filter(isCodeCase).length;
}
